module.exports = __webpack_public_path__ + "media/images/redrock/signup-header-desktop-f139af9ec3cd0d3bb93ed0d43ab84d69.jpeg";